"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartitionLayout = void 0;
exports.PartitionLayout = Object.freeze({
    sunburst: 'sunburst',
    treemap: 'treemap',
    icicle: 'icicle',
    flame: 'flame',
    mosaic: 'mosaic',
    waffle: 'waffle',
});
//# sourceMappingURL=config_types.js.map